'use strict';

module Patersons {

    export class PasswordValidationComponent implements ng.IComponentOptions {
        templateUrl: string = 'assets/templates/common/components/passwordValidation.component.html';
        bindings: any = {
            password: '<',
            onValidation: '<'
        };
        controller: any = PasswordValidationCtrl
        
    }
    export class PasswordValidationCtrl {
        private $ctrl: any;
        private password: string;
        validUppercase: boolean;
        validLowercase: boolean;
        validNumber: boolean;
        validSpecial: boolean;
        valid: boolean;
        onValidation: any;
        constructor(){
            this.$ctrl = this;
            this.resetValidation();
        }
        private resetValidation() {
            this.validUppercase = false;
            this.validLowercase = false;
            this.validNumber = false;
            this.validSpecial = false;
            this.valid = false;
        }
        private validate() {
            this.resetValidation();
            if(this.password){
                if(this.password.match(/[A-Z]/g)){
                    this.validUppercase = true;
                }
                if(this.password.match(/[a-z]/g)){
                    this.validLowercase = true;
                }
                if(this.password.match(/[0-9]/g)){
                    this.validNumber = true;
                }
                if(this.password.match(/[#$^+=!*()@%&]/g)){
                    this.validSpecial = true;
                }
                if(this.validUppercase &&
                    this.validLowercase && 
                    this.validNumber && 
                    this.validSpecial) {
                        this.valid = true;
                    }
                    if(this.onValidation){
                        this.onValidation(this.valid)
                    }
            }
        }
        private $onChanges(changesObj){
            this.validate()
        }
    }
}